import React from 'react';
import './PetAnimations.css';

export default function FoxSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#D4762A';
  const lightColor = '#FFF5E0';
  const darkColor = color ? '#6B3A10' : '#8B4513';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Big fluffy tail */}
      <path
        d="M85 74C92 66 102 52 105 44C107 38 104 36 100 40C94 46 88 58 82 70"
        fill={bodyColor}
        stroke={bodyColor}
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M102 42C104 40 106 38 105 43C104 48 100 52 96 56"
        fill={lightColor}
        stroke="none"
      />
      {/* Body */}
      <ellipse cx="60" cy="76" rx="28" ry="22" fill={bodyColor} />
      {/* Belly */}
      <ellipse cx="60" cy="82" rx="16" ry="13" fill={lightColor} />
      {/* Legs */}
      <rect x="38" y="88" width="10" height="14" rx="5" fill={darkColor} />
      <rect x="72" y="88" width="10" height="14" rx="5" fill={darkColor} />
      <rect x="46" y="90" width="8" height="12" rx="4" fill={darkColor} />
      <rect x="66" y="90" width="8" height="12" rx="4" fill={darkColor} />
      {/* Head */}
      <ellipse cx="60" cy="46" rx="22" ry="20" fill={bodyColor} />
      {/* Face white */}
      <path d="M48 42C48 42 54 56 60 56C66 56 72 42 72 42C72 42 68 36 60 36C52 36 48 42 48 42Z" fill={lightColor} />
      {/* Ears - big and pointy */}
      <path d="M40 32L28 8L50 26Z" fill={bodyColor} />
      <path d="M42 30L32 12L49 26Z" fill={darkColor} />
      <path d="M80 32L92 8L70 26Z" fill={bodyColor} />
      <path d="M78 30L88 12L71 26Z" fill={darkColor} />
      {/* Eyes */}
      <ellipse cx="50" cy="43" rx="4" ry="4.5" fill="white" />
      <ellipse cx="70" cy="43" rx="4" ry="4.5" fill="white" />
      <ellipse cx="51.5" cy="43.5" rx="2.5" ry="3" fill="#D4762A" />
      <ellipse cx="71.5" cy="43.5" rx="2.5" ry="3" fill="#D4762A" />
      <ellipse cx="51.5" cy="43.5" rx="1.5" ry="2" fill="#2C2419" />
      <ellipse cx="71.5" cy="43.5" rx="1.5" ry="2" fill="#2C2419" />
      <circle cx="52.5" cy="42" r="1" fill="white" />
      <circle cx="72.5" cy="42" r="1" fill="white" />
      {/* Nose */}
      <ellipse cx="60" cy="50" rx="3" ry="2" fill="#2C2419" />
      {/* Mouth */}
      <path d="M60 52C58 54 56 54 55 53.5" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      <path d="M60 52C62 54 64 54 65 53.5" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
    </svg>
  );
}
